export default {
  DATE_FORMAT: 'MMM D, YYYY',
};
